import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { BotIcon, SmileIcon, CheckSquareIcon, HomeIcon } from 'lucide-react';
interface BottomNavProps {
  onBackClick?: () => void;
}
export function BottomNav({
  onBackClick
}: BottomNavProps) {
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === '/';
  const navItems = [{
    path: '/',
    icon: HomeIcon,
    label: '首页'
  }, {
    path: '/aibot',
    icon: BotIcon,
    label: 'AIbot'
  }, {
    path: '/growth',
    icon: SmileIcon,
    label: '游戏'
  }, {
    path: '/tasks',
    icon: CheckSquareIcon,
    label: '学习'
  }];
  const handleBackClick = () => {
    if (onBackClick) {
      onBackClick();
    } else {
      navigate(-1);
    }
  };
  return <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 safe-area-bottom z-50" data-id="element-88">
      <div className="grid grid-cols-5 h-16" data-id="element-89">
        {navItems.map(item => {
        const Icon = item.icon;
        const isActive = location.pathname === item.path;
        return <Link key={item.path} to={item.path} className={`flex flex-col items-center justify-center transition-colors ${isActive ? 'text-indigo-600' : 'text-gray-500 active:text-indigo-400'}`} data-id="element-90">
              <Icon size={20} className="mb-1" data-id="element-91" />
              <span className="text-xs font-medium" data-id="element-92">{item.label}</span>
            </Link>;
      })}
      </div>
    </nav>;
}